<template>
    <div class="tickets-board-wrapper">
        <div class="tickets-board d-flex overflow-x-auto pb-2">
            <tickets-board-column
                v-for="s in orderedStatuses"
                :key="s.id_status_ticket"
                :status="s"
                :tickets="ticketsPorStatus[s.id_status_ticket] || []"
                :total="Number(totaisPorStatus[s.id_status_ticket]) || 0"
                :loading="loading"
                :carregando-mais="carregandoColuna[s.id_status_ticket] === true"
                :cards-inverted="columnCardsInvertedMap[String(s.id_status_ticket)] === true"
                :status-drag-enabled="statusDragEnabled && !loading"
                :drop-highlight="dropHighlightStatusId === Number(s.id_status_ticket)"
                :show-print="showPrint"
                @card-click="$emit('card-click', $event)"
                @print-ticket="$emit('print-ticket', $event)"
                @carregar-mais="$emit('carregar-mais', Number(s.id_status_ticket))"
                @toggle-cards-invert="toggleColumnCardsInvert(s.id_status_ticket)"
                @column-drag-over="onColumnDragOver"
                @card-drop="onCardDrop"
            />
        </div>
    </div>
</template>

<script>
import { CHAVES_SO_SUPORTE } from '@/utils/ticketFluxoSuporte';
import TicketsBoardColumn from './TicketsBoardColumn.vue';

export default {
    name: 'TicketsBoard',
    components: { TicketsBoardColumn },
    props: {
        /** Quem não edita cards só tem a coluna Pendente quando há ticket próprio nela. */
        ocultarPendenteVazio: {
            type: Boolean,
            default: false
        },
        /** Cards já carregados de cada coluna (chave = id_status_ticket), na ordem vinda do servidor. */
        ticketsPorStatus: {
            type: Object,
            default: () => ({})
        },
        /** Total de cada coluna conforme os filtros (contagem do servidor, não só os cards carregados). */
        totaisPorStatus: {
            type: Object,
            default: () => ({})
        },
        /** Colunas buscando a próxima página (rolagem infinita). */
        carregandoColuna: {
            type: Object,
            default: () => ({})
        },
        statusList: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        /** Keys: String(id_status_ticket); value true = reverse card order in that column */
        columnCardsInverted: {
            type: Object,
            default: () => ({})
        },
        /** Drag cards between columns to change status (parent calls API). */
        statusDragEnabled: {
            type: Boolean,
            default: false
        },
        /** Mostra o ícone de impressora em cada card. */
        showPrint: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return { dropHighlightStatusId: null };
    },
    mounted() {
        window.addEventListener('dragend', this.clearDropHighlight);
    },
    beforeDestroy() {
        window.removeEventListener('dragend', this.clearDropHighlight);
    },
    computed: {
        columnCardsInvertedMap() {
            const m = this.columnCardsInverted;
            return m && typeof m === 'object' ? m : {};
        },
        orderedStatuses() {
            const temSuporte = Object.values(this.ticketsPorStatus || {}).some((lista) => (lista || []).some(
                (t) => String(t.tipo_ticket_extenso || '').trim().toUpperCase() === 'SUPORTE SISTEMA (MERUSTRAKER)'
            ));
            // Colunas exclusivas do fluxo de suporte só aparecem quando há ticket de suporte no quadro.
            const visiveis = (this.statusList || []).filter((s) => {
                if (this.ocultarPendenteVazio && s.chave_i18n === 'status.pendente') {
                    return Number(this.totaisPorStatus[s.id_status_ticket]) > 0;
                }
                return temSuporte || CHAVES_SO_SUPORTE.indexOf(s.chave_i18n) < 0;
            });
            return visiveis.slice().sort((a, b) => {
                const aOrder = a.ordem != null ? Number(a.ordem) : Number(a.id_status_ticket || 0);
                const bOrder = b.ordem != null ? Number(b.ordem) : Number(b.id_status_ticket || 0);
                if (aOrder === bOrder) return Number(a.id_status_ticket || 0) - Number(b.id_status_ticket || 0);
                return aOrder - bOrder;
            });
        }
    },
    methods: {
        toggleColumnCardsInvert(statusId) {
            const key = String(statusId);
            const prev = this.columnCardsInvertedMap;
            const next = { ...prev, [key]: !prev[key] };
            this.$emit('update:columnCardsInverted', next);
        },
        clearDropHighlight() {
            this.dropHighlightStatusId = null;
        },
        onColumnDragOver(statusId) {
            if (!this.statusDragEnabled || this.loading) return;
            this.dropHighlightStatusId = statusId;
        },
        onCardDrop(payload) {
            this.clearDropHighlight();
            if (!payload || !this.statusDragEnabled || this.loading) return;
            this.$emit('ticket-status-drop', payload);
        }
    }
};
</script>

<style scoped>
.tickets-board-wrapper {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}
.tickets-board {
    gap: 12px;
    min-height: 0;
    flex: 1;
}
.tickets-board::-webkit-scrollbar {
    height: 8px;
}
.tickets-board::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 4px;
}
</style>
